import React from "react";
import Image from "next/image";

const newsItems = [
  {
    id: 1,
    category: "IMPACTOVERSE",
    title: "Impactoverse x Hanson Robotics",
    description: "Partnering on education through Sofia.",
    image: "/images/sofia_robot.jpg",
  },
  {
    id: 2,
    category: "IMPACT ARTS",
    title: "Donate Impact Art to charities of your choice!",
    description: "You can now make Impact Art donations to charities.",
    image: "/images/donate_nfts.jpg",
  },
  {
    id: 3,
    category: "GAMING",
    title: "Play for impact and earn",
    description: "Complete challenges on the gaming ecosystem to earn rewards.",
    image: "/images/gaming.jpg",
  },
];

const NewsSection = () => {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden bg-white dark:bg-jacarta-800">
      <div className="container mx-auto px-4 md:px-8">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <h3 className="text-[#4E6EB6] text-xl md:text-2xl font-medium tracking-wider mb-2">
            NEWS
          </h3>
          <h2 className="text-[#374151] dark:text-[#EDEDED] font-bold text-3xl md:text-4xl">
            Learn What's New on Impactoverse
          </h2>
        </div>

        {/* News Cards Grid */}
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16 items-start justify-center max-w-7xl mx-auto">
          {newsItems.map((item) => (
            <div
              key={item.id}
              className="bg-[#F4F5FB] dark:bg-[#1F233F] border border-[#4E6EB6] rounded-lg p-4 w-full max-w-[401px] flex flex-col gap-4"
            >
              {/* Category Tag */}
              <h3 className="text-[#374151] dark:text-[#EDEDED] font-semibold text-base text-center leading-10">
                {item.category}
              </h3>

              {/* Content Container */}
              <div className="flex flex-col gap-4">
                {/* Logo Section - Conditional Height */}
                {item.hasLogo && (
                  <div className="h-[60px] flex items-center justify-start">
                    <div className="flex items-center gap-2 px-3">
                      <div className="relative">
                        <div className="w-[18px] h-[18px] bg-[#374151] dark:bg-[#EDEDED] rounded-full flex items-center justify-center p-2">
                          <div className="w-3 h-3 relative">
                            <Image
                              src="/images/impacto_hanson_robot.svg"
                              alt="Impactoverse x Hanson Robotics"
                              fill
                              className="object-contain"
                            />
                          </div>
                        </div>
                        <div className="absolute -top-2 -right-2 w-7 h-7">
                          <Image
                            src="/images/hanson_robotics_logo.svg"
                            alt="Hanson Robotics Logo"
                            fill
                            className="object-contain"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Title Section - Fixed Height for Alignment */}
                <div className="h-[80px] flex items-start mb-2">
                  <h4 className="text-[#374151] dark:text-[#EDEDED] font-semibold text-2xl md:text-[28px] leading-tight">
                    {item.title}
                  </h4>
                </div>

                {/* Image - Now aligned horizontally */}
                <div className="w-full h-[296px] relative rounded overflow-hidden">
                  <Image
                    src={item.image}
                    alt={item.title}
                    fill
                    className="object-cover"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                </div>

                {/* Description */}
                <div className="flex flex-col gap-4">
                  <p className="text-[#374151] dark:text-[#EDEDED] font-medium text-lg md:text-xl leading-relaxed">
                    {item.description}
                  </p>
                </div>

                {/* Learn More Button */}
                <div className="flex justify-between items-center">
                  <button className="bg-[#4E6EB6] text-white font-normal text-base px-4 py-2 rounded-lg border-2 border-[#4E6EB6] shadow-lg hover:bg-[#4E6EB6]/90 transition-colors h-[52px] flex items-center justify-center min-w-[120px]">
                    Learn More
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
